import type { UseNextSanityImageBuilder } from "next-sanity-image";

export type CropAspect = number | string | undefined;

export function parseCropAspect(input: CropAspect): number | undefined {
  if (input == null) return undefined;
  if (typeof input === "number") {
    return Number.isFinite(input) && input > 0 ? input : undefined;
  }
  const match = input
    .trim()
    .match(/^(\d+(?:\.\d+)?)\s*[/:]\s*(\d+(?:\.\d+)?)$/);
  if (match) {
    const w = Number(match[1]);
    const h = Number(match[2]);
    if (w > 0 && h > 0) return w / h;
  }
  const num = Number(input);
  return Number.isFinite(num) && num > 0 ? num : undefined;
}

export function buildSanityImageBuilder({
  cropAspect,
  quality = 85,
}: {
  cropAspect?: CropAspect;
  quality?: number;
}): UseNextSanityImageBuilder {
  const aspect = parseCropAspect(cropAspect);

  return (imageUrlBuilder, options) => {
    const width = options.width || options.originalImageDimensions.width;
    let builder = imageUrlBuilder.width(width).quality(quality).auto("format");

    if (aspect) {
      const height = Math.max(1, Math.round(width / aspect));
      builder = builder.height(height);
    } else {
      builder = builder.fit("clip");
    }

    return builder;
  };
}
